import React, { useState, useContext, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus, FaHome, FaExclamationTriangle, FaMapMarkerAlt } from "react-icons/fa";
import Iller from "../../il-ilce.json";
// import { UserContext } from "../../context/UserContext.js";
import { useToast } from "../../context/ToastContext.js";
import "./AddressComponent.css";
import {
  useGetAddressesQuery,
  useAddAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
} from "../../services/userApi.js";
import Loader from "../Loader.js";

const AddressComponent = () => {
  // const { getAddresses, addAddress, updateAddress, deleteAddress } = useContext(UserContext);
  const { data: addressesData, isLoading: isLoadingAddresses, isError: isErrorAddresses, refetch: refetchAddresses } = useGetAddressesQuery();
  const [addAddress, { isLoading: isAddingAddress }] = useAddAddressMutation();
  const [updateAddress, { isLoading: isUpdatingAddress }] = useUpdateAddressMutation();
  const [deleteAddress, { isLoading: isDeletingAddress }] = useDeleteAddressMutation();

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingAddress, setEditingAddress] = useState(null);
  const [addressForm, setAddressForm] = useState({
    id: null,
    title: "",
    ad: "",
    soyad: "",
    email: "",
    telefon: "05",
    addressText: "",
    il: "",
    ilce: ""
  });
  const [iller, setIller] = useState(Iller.iller);
  const [ilceler, setIlceler] = useState([]);
  const { showToast } = useToast();

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        // const data = await getAddresses();
        // setAddresses(data || []);
        if (addressesData) {
          setAddresses(addressesData || []);
        }
      } catch (error) {
        console.error("Adresler yüklenirken hata:", error);
        showToast("Adresler yüklenirken bir hata oluştu", "error");
      } finally {
        setLoading(false);
      }
    };

    // fetchAddresses();
    // }, [getAddresses, showToast]);
    if (isLoadingAddresses) {
      setLoading(true);
    } else {
      setLoading(false);
      if (addressesData) {
        setAddresses(addressesData || []);
      }
      if (isErrorAddresses) {
        console.error("Adresler yüklenirken hata:", isErrorAddresses);
        showToast("Adresler yüklenirken bir hata oluştu", "error");
      }
    }
  }, [addressesData, isLoadingAddresses, isErrorAddresses, showToast]);

  const openAddressModal = (address = null) => {
    if (address) {
      setEditingAddress(address.id);
      setAddressForm({
        id: address.id,
        title: address.title,
        ad: address.ad,
        soyad: address.soyad,
        email: address.email,
        telefon: address.telefon || "05",
        addressText: address.addressText,
        il: address.il || "",
        ilce: address.ilce || ""
      });

      if (address.il) {
        const secilenIl = iller.find((il) => il.il_adi === address.il);
        setIlceler(secilenIl ? secilenIl.ilceler : []);
      }
    } else {
      setEditingAddress(null);
      setAddressForm({
        id: null,
        title: "",
        ad: "",
        soyad: "",
        email: "",
        telefon: "05",
        addressText: "",
        il: "",
        ilce: ""
      });
      setIlceler([]);
    }
    setShowAddressModal(true);
  };

  const closeAddressModal = () => {
    setShowAddressModal(false);
    setEditingAddress(null);
  };

  const handlePhoneKeyDown = (e) => {
    const { selectionStart, selectionEnd } = e.target;
    
    // Backspace veya Delete tuşlarına basıldığında
    if (e.key === 'Backspace' || e.key === 'Delete') {
      // Cursor 05'in içinde ise işlemi engelle
      if (selectionStart <= 2 || (selectionStart <= 2 && selectionEnd <= 2)) {
        e.preventDefault();
        // Cursor'u 05'ten sonra konumlandır
        setTimeout(() => {
          e.target.setSelectionRange(2, 2);
        }, 0);
        return;
      }
    }
    
    // Home tuşuna basıldığında cursor'u 05'ten sonra konumlandır
    if (e.key === 'Home') {
      e.preventDefault();
      e.target.setSelectionRange(2, 2);
      return;
    }
    
    // Arrow tuşları ile cursor'un 05'in içine girmesini engelle
    if (e.key === 'ArrowLeft' && selectionStart <= 2) {
      e.preventDefault();
      e.target.setSelectionRange(2, 2);
      return;
    }
  };

  const handlePhoneInput = (e) => {
    const { value } = e.target;
    
    // Sadece rakamları al
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    
    // Eğer 05 ile başlamıyorsa veya 2 karakterden az ise düzelt
    if (!sanitizedValue.startsWith('05') || sanitizedValue.length < 2) {
      // Kullanıcının girdiği ekstra rakamları al (05'ten sonraki kısım)
      const userDigits = sanitizedValue.replace(/^0?5?/, '');
      const newValue = '05' + userDigits;
      
      // Maksimum 11 karakter sınırı
      const finalValue = newValue.length > 11 ? newValue.substring(0, 11) : newValue;
      
      setAddressForm(prev => ({ ...prev, telefon: finalValue }));
      
      // Cursor pozisyonunu düzelt
      setTimeout(() => {
        const pos = Math.min(finalValue.length, Math.max(2, finalValue.length));
        e.target.setSelectionRange(pos, pos);
      }, 0);
      
      return;
    }
    
    // Maksimum 11 karakter kontrolü
    if (sanitizedValue.length > 11) {
      setAddressForm(prev => ({ ...prev, telefon: sanitizedValue.substring(0, 11) }));
      return;
    }
    
    // Normal durumda değeri ayarla
    setAddressForm(prev => ({ ...prev, telefon: sanitizedValue }));
  };

  const formatPhoneNumber = (number) => {
    if (!number) return '';
    return number.replace(/(\d{4})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  };

  const handleAddressFormChange = (e) => {
    const { name, value } = e.target;

    if (name === 'telefon') {
      handlePhoneInput(e);
      return;
    }

    if (name === "il") {
      const secilenIl = iller.find((il) => il.il_adi === value);
      setIlceler(secilenIl ? secilenIl.ilceler : []);
      setAddressForm(prev => ({
        ...prev,
        [name]: value,
        ilce: ""
      }));
    } else {
      setAddressForm(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();

    // Adres uzunluğu kontrolü
    if (addressForm.addressText.trim().length < 10) {
      showToast("Adres en az 10 karakter olmalıdır", "error");
      return;
    }

    try {
      if (editingAddress) {
        // await updateAddress(editingAddress, addressForm);
        // const updatedAddresses = await getAddresses();
        // setAddresses(updatedAddresses);
        await updateAddress({ addressId: editingAddress, addressData: addressForm }).unwrap();
        refetchAddresses();
        showToast("Adres başarıyla güncellendi", "success");
      } else {
        // await addAddress(addressForm);
        // const updatedAddresses = await getAddresses();
        // setAddresses(updatedAddresses);
        await addAddress(addressForm).unwrap();
        refetchAddresses();
        showToast("Yeni adres başarıyla eklendi", "success");
      }
      closeAddressModal();
    } catch (error) {
      console.error("Adres işlemi başarısız:", error);
      showToast("Adres işlemi sırasında bir hata oluştu", "error");
    }
  };

  const openDeleteModal = (address) => {
    setAddressToDelete(address);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setAddressToDelete(null);
  };

  const confirmDeleteAddress = async () => {
    if (!addressToDelete) return;

    try {
      // await deleteAddress(addressToDelete.id);
      // const updatedAddresses = await getAddresses();
      // setAddresses(updatedAddresses);
      await deleteAddress(addressToDelete.id).unwrap();
      refetchAddresses();
      showToast("Adres başarıyla silindi", "success");
      closeDeleteModal();
    } catch (error) {
      console.error("Adres silme işlemi başarısız:", error);
      showToast("Adres silinirken bir hata oluştu", "error");
    }
  };

  // Adres alanı onblur kontrolü
  const handleAddressBlur = () => {
    if (addressForm.addressText.trim().length < 10) {
      showToast("Adres en az 10 karakter olmalıdır", "error");
    }
  };

  if (isLoadingAddresses) {
    return (
      <div className="user-loading-container">
        <div className="spinner-container">
          <Loader size={40}/>
        </div>
      </div>
    );
  }

  return (
    <div className="user-addresses-container">
      <div className="address-header">
        <div className="user-address-actions">
          <button
            className="user-add-address-button"
            onClick={() => openAddressModal()}
          >
            <FaPlus size={14} /> Yeni Adres Ekle
          </button>
        </div>
      </div>

      <div className="user-address-list">
        {addresses && addresses.length > 0 ? (
          addresses.map(address => (
            <div className="user-address-card" key={address.id}>
              <h4>
                <FaHome className="me-2" /> {address.title}
              </h4>
              <p>
                {address.ad} {address.soyad} <br />
                {address.addressText} <br />
                {address.ilce}, {address.il} <br />
                {address.telefon}
              </p>
              <div className="user-address-actions">
                <button
                  className="user-edit-address-button"
                  onClick={() => openAddressModal(address)}
                >
                  <FaEdit size={14} /> Düzenle
                </button>
                <button
                  className="user-delete-address-button"
                  onClick={() => openDeleteModal(address)}
                >
                  <FaTrash size={14} /> Sil
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="user-no-address-message">
            <FaMapMarkerAlt size={24} className="mb-2" />
            <p>Henüz kayıtlı adresiniz bulunmamaktadır.</p>
            <p>Alışveriş yaparken kolaylık sağlamak için adres ekleyebilirsiniz.</p>
          </div>
        )}
      </div>

      {/* Adres Ekleme/Düzenleme Modalı */}
      {showAddressModal && (
        <div className="user-address-modal-overlay">
          <div className="user-address-modal">
            <h3>{editingAddress ? "Adresi Düzenle" : "Yeni Adres Ekle"}</h3>
            <form onSubmit={handleAddressSubmit} className="user-address-modal-form">
              <div className="user-form-user">
                <label>Adres Başlığı</label>
                <input
                  type="text"
                  name="title"
                  value={addressForm.title}
                  onChange={handleAddressFormChange}
                  placeholder="Örn: Ev, İş"
                  required
                />
              </div>

              <div className="user-form-row">
                <div className="user-form-user">
                  <label>Ad</label>
                  <input
                    type="text"
                    name="ad"
                    value={addressForm.ad}
                    onChange={handleAddressFormChange}
                    placeholder="Alıcı ad"
                    required
                  />
                </div>
                <div className="user-form-user">
                  <label>Soyad</label>
                  <input
                    type="text"
                    name="soyad"
                    value={addressForm.soyad}
                    onChange={handleAddressFormChange}
                    placeholder="Alıcı soyad"
                    required
                  />
                </div>
              </div>

              <div className="user-form-row">
                <div className="user-form-user">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={addressForm.email}
                    onChange={handleAddressFormChange}
                    placeholder="Email"
                    required
                  />
                </div>
                <div className="user-form-user">
                  <label>Telefon</label>
                  <input
                    type="tel"
                    name="telefon"
                    value={formatPhoneNumber(addressForm.telefon)}
                    onChange={handleAddressFormChange}
                    onKeyDown={handlePhoneKeyDown}
                    placeholder="Telefon"
                    maxLength="14"
                    required
                  />
                </div>
              </div>

              <div className="user-form-row">
                <div className="user-form-user">
                  <label>İl</label>
                  <select
                    name="il"
                    value={addressForm.il}
                    onChange={handleAddressFormChange}
                    required
                  >
                    <option value="">İl Seçiniz</option>
                    {iller.map((il, index) => (
                      <option key={index} value={il.il_adi}>
                        {il.il_adi}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="user-form-user">
                  <label>İlçe</label>
                  <select
                    name="ilce"
                    value={addressForm.ilce}
                    onChange={handleAddressFormChange}
                    required
                    disabled={!addressForm.il}
                  >
                    <option value="">İlçe Seçiniz</option>
                    {ilceler.map((ilce, index) => (
                      <option key={index} value={ilce.ilce_adi}>
                        {ilce.ilce_adi}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="user-form-user">
                <label>Adres</label>
                <textarea
                  name="addressText"
                  value={addressForm.addressText}
                  onChange={handleAddressFormChange}
                  onBlur={handleAddressBlur}
                  placeholder="Adresinizi giriniz"
                  required
                ></textarea>
              </div>
              <div className="user-address-modal-actions">
                <button type="button" className="user-cancel-button" onClick={closeAddressModal}>
                  İptal
                </button>
                <button
                  type="submit"
                  className="user-save-address-button"
                  disabled={isAddingAddress || isUpdatingAddress}
                >
                  {isAddingAddress || isUpdatingAddress ? "Kaydediliyor..." : editingAddress ? "Güncelle" : "Kaydet"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Adres Silme Onay Modalı */}
      {showDeleteModal && addressToDelete && (
        <div className="user-address-modal-overlay">
          <div className="user-address-modal delete-modal">
            <div className="delete-modal-content">
              <div className="delete-icon">
                <FaExclamationTriangle size={36} color="#f44336" />
              </div>
              <h3>Adresi Sil</h3>
              <p>"{addressToDelete.title}" adresini silmek istediğinizden emin misiniz?</p>
              <p className="delete-warning">Bu işlem geri alınamaz!</p>

              <div className="user-address-modal-actions">
                <button type="button" className="user-cancel-button" onClick={closeDeleteModal}>
                  İptal
                </button>
                <button
                  type="button"
                  className="user-delete-confirm-button"
                  onClick={confirmDeleteAddress}
                  disabled={isDeletingAddress}
                >
                  {isDeletingAddress ? "Siliniyor..." : "Evet, Sil"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressComponent; 